import { createContext, useContext, useState } from "react";

const defaultCanvasValue = {
  canvas: null,
  setCanvas: () => {},
  clearCanvasState: ()=>{}
};

export const CanvasContext = createContext(defaultCanvasValue);

export const CanvasProvider = ({ children }) => {
  const [canvas, setCanvas] = useState(null);

  const clearCanvasState = () => {
    console.log("CLearing canvas")
    setCanvas(null)
  };

  return (
    <CanvasContext.Provider
      value={{ ...defaultCanvasValue, canvas, setCanvas }}
    >
      {children}
    </CanvasContext.Provider>
  );
};

export const useCanvasContext = () => {
  return useContext(CanvasContext);
};
